const CEP_RANGES = {
  SP: [{ start: 1000000,  end: 19999999 }],
  RJ: [{ start: 20000000, end: 28999999 }],
  ES: [{ start: 29000000, end: 29999999 }],
  MG: [{ start: 30000000, end: 39999999 }],
  PR: [{ start: 80000000, end: 87999999 }],
  SC: [{ start: 88000000, end: 89999999 }],
  RS: [{ start: 90000000, end: 99999999 }]
};

const GROUP1_STATES = ['SP', 'RJ', 'ES', 'MG', 'PR', 'SC', 'RS'];

function detectCepGroup(cep) {
  const num = parseInt(cep.replace(/\D/g, ''), 10);
  if (isNaN(num)) return '2';
  for (const state of GROUP1_STATES) {
    for (const range of CEP_RANGES[state]) {
      if (num >= range.start && num <= range.end) return '1';
    }
  }
  return '2';
}

document.addEventListener('DOMContentLoaded', () => {
  const scriptTag   = document.getElementById('cep-header-js');
  const customerZip = scriptTag ? (scriptTag.getAttribute('customer') || '') : '';
  const savedZip    = localStorage.getItem('zipCode') || '';
  const zipCode     = savedZip || customerZip;

  if (zipCode) {
    localStorage.setItem('zipCode', zipCode);
    if (!localStorage.getItem('cepGroup')) {
      localStorage.setItem('cepGroup', detectCepGroup(zipCode));
    }
    updateHeaderDisplay(zipCode);
    if (typeof window.updateCepProgressBar === 'function') {
      window.updateCepProgressBar();
    }
  }

  initCepTooltipDisclosure();
});

function updateHeaderDisplay(zipCode) {
  document.querySelectorAll('.label').forEach((el) => {
    if (!zipCode) {
      el.classList.remove('user-cep-container');
      if (el.dataset.cepDefault) {
        el.innerHTML = el.dataset.cepDefault;
      }
      return;
    }
    if (!el.dataset.cepDefault) {
      el.dataset.cepDefault = el.innerHTML;
    }
    el.classList.add('user-cep-container');
    el.innerHTML = '<p>CEP de entrega</p><b>' + zipCode + '</b>';
  });
}

function initCepTooltipDisclosure() {
  const wrapper = document.querySelector('.cep-tooltip-wrapper');
  const tooltip = wrapper ? wrapper.querySelector('.cep-tooltip-container') : null;
  const zipInput = wrapper ? wrapper.querySelector('#zipCode') : null;
  if (!wrapper || !tooltip) return;

  const mobileMedia = window.matchMedia('(max-width: 749px)');
  let keyboardOverlayTimer;

  const showKeyboardOverlay = () => {
    clearTimeout(keyboardOverlayTimer);
    keyboardOverlayTimer = setTimeout(() => {
      if (!mobileMedia.matches || document.activeElement !== zipInput) return;
      tooltip.classList.remove('hidden');
      document.body.classList.add('cep-tooltip-keyboard-open');
    }, 0);
    document.querySelector('.shopify-section-group-header-group').style.zIndex = 9999;
  };

  const hideKeyboardOverlay = () => {
    clearTimeout(keyboardOverlayTimer);
    document.body.classList.remove('cep-tooltip-keyboard-open');
    document.querySelector('.shopify-section-group-header-group').style.zIndex = 4;
  };

  const showTooltip = () => {
    tooltip.classList.remove('hidden');
  };

  const hideTooltip = () => {
    tooltip.classList.add('hidden');
    hideKeyboardOverlay();
  };

  window.hideCepTooltipOverlay = hideKeyboardOverlay;

  wrapper.addEventListener('click', (event) => {
    event.stopPropagation();
    showTooltip();
  });

  document.addEventListener('click', (event) => {
    if (!wrapper.contains(event.target)) {
      hideTooltip();
    }
  });

  window.hideCepTooltip = hideTooltip;

  if (zipInput) {
    zipInput.addEventListener('focus', showKeyboardOverlay);
    zipInput.addEventListener('blur', hideKeyboardOverlay);
  }

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', (event) => {
      if (!event.matches) {
        hideKeyboardOverlay();
      }
    });
  }

  if (!localStorage.getItem('zipCode')) {
    showTooltip();
  }
}
